import { useState } from 'react';
import { UsageRecord } from '../types';

let selectedRecords: UsageRecord[] = [];
const listeners: (() => void)[] = [];

const notifyListeners = () => {
  listeners.forEach(listener => listener());
};

export const useUsageRecordsSelection = () => {
  const [, forceUpdate] = useState({});
  
  const rerender = () => forceUpdate({});
  
  if (!listeners.includes(rerender)) {
    listeners.push(rerender);
  }

  const setSelectedRecords = (records: UsageRecord[]) => {
    selectedRecords = records;
    notifyListeners();
  };

  const clearSelection = () => {
    selectedRecords = [];
    notifyListeners();
  };

  return {
    selectedRecords,
    setSelectedRecords,
    clearSelection,
    handleClearSelection: clearSelection,
    hasSelection: selectedRecords.length > 0
  };
};